import React, { useCallback, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import CardNews from '../../shared/components/CardNews/CardNews'
import useEmblaCarousel from 'embla-carousel-react'
import Button from '../../shared/components/Button/Button'
import { motion, AnimatePresence } from 'framer-motion'
import './styles.scss'

const Carousel = ({ posts, kind_of_news }) => {
  const [emblaRef, emblaApi] = useEmblaCarousel({
    containScroll: 'trimSnaps',
    slidesToScroll: 1,
    loop: false,
  })
  const prevButtonRef = useRef(null)
  const nextButtonRef = useRef(null)
  const scrollPrev = useCallback(() => {
    if (emblaApi) emblaApi.scrollPrev()
  }, [emblaApi])

  const scrollNext = useCallback(() => {
    if (emblaApi) emblaApi.scrollNext()
  }, [emblaApi])

  useEffect(() => {
    if (emblaApi) {
      const onSelect = () => {
        prevButtonRef.current.disabled = !emblaApi.canScrollPrev()
        nextButtonRef.current.disabled = !emblaApi.canScrollNext()
      }
      emblaApi.on('select', onSelect)
      return () => emblaApi.off('select', onSelect)
    }
  }, [emblaApi])

  return (
    <div className="embla" ref={emblaRef}>
      <div className="embla__container">
        <AnimatePresence>
          {posts?.map((post, index) => (
            <motion.div
              key={index}
              transition={{
                duration: 0.7,
                delay: 0.7,
              }}
              viewport={{
                once: true,
              }}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              exit={{ opacity: 1 }}
              className="embla__slide"
            >
              <CardNews
                imageSrc={post.featuredImage}
                title={post.title}
                description={post.excerpt}
                link={post.url}
                kind_of_news={kind_of_news}
                dataIndex={index}
                target={kind_of_news === 'Blog' ? '_parent' : '_blank'}
              />
            </motion.div>
          ))}
        </AnimatePresence>
      </div>
      <div className="embla__footer">
        {kind_of_news === 'Blog' ? (
          <Button
            className="readmore__post"
            name="READ MORE"
            link="https://blog.allinweddings.com"
            type="button"
            showLabel={true}
            icon="ArrowRight"
          />
        ) : (
          <div className="col-span-6" />
        )}
        <div className="embla__buttons">
          <Button
            className="embla__prev"
            action={scrollPrev}
            ref={prevButtonRef}
            type="icon"
            icon="ArrowLeft"
            iconFill="transparent"
            iconStroke="#1B1F24"
            strokeCircle="#1B1F24"
          />
          <Button
            className="embla__next"
            action={scrollNext}
            ref={nextButtonRef}
            type="icon"
            icon="ArrowRight"
            iconFill="transparent"
            iconStroke="#1B1F24"
            strokeCircle="#1B1F24"
          />
        </div>
      </div>
    </div>
  )
}

Carousel.propTypes = {
  posts: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      title: PropTypes.string,
      excerpt: PropTypes.string,
      url: PropTypes.string,
      featuredImage: PropTypes.string,
    }),
  ).isRequired,
  kind_of_news: PropTypes.string,
}

export default Carousel
